module.exports = __webpack_public_path__ + "img/news-announcements.22fc5f97.jpg";